export default "__VITE_ASSET__CA7e_oWa__"